<template>
  <b-modal ref="PaymentsChargeOffModal"
           :no-close-on-backdrop="true" :no-enforce-focus="true" size="sm" @hidden="clearPaymentsChargeOffData">
    <div slot="modal-title">
      <div class="d-flex">
        <h5 class="modal-title">
          {{$t('modal_dialogs.payments.charge_off_money')}}
        </h5>
      </div>
    </div>
    <div>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.type')}}</label>
          <multiselect v-model="paymentsChargeOffData.is_charge_off" :max-height="200"
                       placeholder="Choose charge off type" label="name" track-by="name"
                       :options="chargeOffTypes" :multiple="false" :close-on-select="true"
                       select-label="" deselect-label="" selected-label=""/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.date')}}</label>
          <datepicker v-model="paymentsChargeOffData.charge_off_date"
                      lang="en" :first-day-of-week="1"/>
        </b-col>
      </b-row>
    </div>
    <div slot="modal-footer" class="w-100 d-flex justify-content-center align-items-center">
      <b-btn size="sm" class="ml-2" variant="success" @click="save"
             title="Confirm" :disabled="!paymentsChargeOffData.charge_off_date || !paymentsChargeOffData.is_charge_off">
        {{$t('buttons.common.confirm')}}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import Datepicker from 'vue2-datepicker';
  import Multiselect from 'vue-multiselect';

  import moment from 'moment';
  import { DATE_FORMAT } from '@/constants';

  export default {
    props: ['paymentsChargeOffToInvoiceCb'],
    components: {
      Multiselect,
      Datepicker
    },
    data() {
      return {
        initialPaymentsChargeOffData: {
          charge_off_date: '',
          is_charge_off: null,
        },
        paymentsChargeOffData: {},
        chargeOffTypes: [
          {value: false, name: 'Under/Over payment'},
          {value: true, name: 'Charge-off'}
        ]
      }
    },
    methods: {
      async save() {
        const data = {
          charge_off_date: this.paymentsChargeOffData.charge_off_date && moment(this.paymentsChargeOffData.charge_off_date).format(DATE_FORMAT),
          is_charge_off: this.paymentsChargeOffData.is_charge_off && this.paymentsChargeOffData.is_charge_off.value
        };
        await this.paymentsChargeOffToInvoiceCb(data);
        this.$refs['PaymentsChargeOffModal'].hide();
      },
      clearPaymentsChargeOffData() {
        this.paymentsChargeOffData = {...this.initialPaymentsChargeOffData};
      }
    },
    mounted() {
      this.$root.$on('openPaymentsChargeOffModal', _ => {
        if (this.$refs['PaymentsChargeOffModal']) {
          this.paymentsChargeOffData = {...this.initialPaymentsChargeOffData};
          this.$refs['PaymentsChargeOffModal'].show();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openPaymentsChargeOffModal');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/PaymentsChargeOffModal.vue